<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g clip-path="url(#clip0_423_2110)"><path fill-rule="evenodd" d="M4 6.085c0-1.189.964-2.153 2.154-2.153h19.692c1.19 0 2.154.964 2.154 2.153v19.693c0 1.19-.964 2.154-2.154 2.154H6.154A2.154 2.154 0 014 25.778V6.085zm2.154-.307a.308.308 0 00-.308.307v3.427h20.308V6.085a.308.308 0 00-.308-.307H6.154zm20 5.58h-9.23v6.44h9.23v-6.44zm0 8.287h-9.23v6.44h8.922c.17 0 .308-.137.308-.307v-6.133zm-11.077 6.44v-6.44h-9.23v6.133c0 .17.137.308.307.308h8.923zM5.847 17.8h9.23v-6.441h-9.23v6.44z" clip-rule="evenodd"/></g><defs><clipPath id="clip0_423_2110"><path d="M0 0h32v32H0z"/></clipPath></defs></svg>
</template>

<script>
export default {
  name: 'editorTableOutline'
}
</script>
